import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { SocketContext } from "../../../context/actions/socket";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'


const MySwal = withReactContent(Swal)

const Unauthorized = ({ className }) => {
  const { backendSocket } = useContext(SocketContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const userDetail = useSelector((state) => state?.user?.user);

  useEffect(() => {
    backendSocket.off("isSubadminLogout").on("isSubadminLogout", (res, err) => {
      if (res) {
        if (res.data && res.data === userDetail._id) {
          console.log(res.role, userDetail.role);
          if (
            res.organization !== userDetail.organization ||
            res.role !== userDetail.role
          ) {
            dispatch({ type: "ISLOADING", data: false });
            dispatch({ type: "LOGOUT", data: {} });
            dispatch({ type: "SET_TEMPDATA", data: {} });
            MySwal.close();
            history.push('/login')
          }
        }
      }
    });
  }, []);

  return (
    <div
      className={`not-found d-flex flex-column flex-fill align-items-center justify-content-center ${className}`}
    >
      <div className="inner">
        <h2>401</h2>
        <h3>Unauthorized Page!</h3>
        <p>Oops! The page you were looking for is Unauthorized.</p>
        <Link to="/" className="btn btn-primary">
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
